import { render } from "./base-overlay.vue?vue&type=template&id=ac18bdb8&ts=true"
import script from "./base-overlay.vue?vue&type=script&lang=ts"
export * from "./base-overlay.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__